<div *ngIf="!loading">
    <p *ngIf="paymentOrders.length == 0">
        There is no vivawallet payment order for this booking.
    </p>
    <div *ngIf="paymentOrders.length > 0">
        <table>
            <tr>
                <th>ID</th>
                <th>Code</th>
                <th>Created</th>
                <th>Status</th>
                <th>Amount</th>
                <th>Created By</th>
            </tr>
            <tr *ngFor="let order of paymentOrders">
                <td>{{order.id!}}</td>
                <td>{{order.orderCode}}</td>
                <td>{{order.created | date:'dd/MM/yyyy hh:mm'}}</td>
                <td>
                    <p *ngIf="order.isPaid">Paid</p>
                    <p *ngIf="!order.isPaid && order.isExpired">Expired</p>
                    <p *ngIf="!order.isPaid && !order.isExpired">To be paid</p>
                </td>
                <td>{{order.amount}}</td>
                <td>{{order.createdBy.name}}</td>
            </tr>
        </table>
    </div>
</div>